import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { Button, IButtonProps } from '../Button';

interface IFilterButton extends IButtonProps {
  filterActive?: boolean;
  appliedFilters?: number;
}

const StyledButton = styled(({ filterActive, ...rest }: IFilterButton) => <Button {...rest} />)`
  padding: ${toRem(theme.space.xs)} ${toRem(theme.space.md)};

  svg {
    margin-right: ${toRem(theme.space.sm)} !important;
  }

  ${({ filterActive }) =>
    filterActive &&
    css`
      background-color: ${theme.color.neutral[800]};
      border-color: ${theme.color.neutral[800]};
      color: ${theme.color.white};

      svg {
        fill: ${theme.color.white};
      }

      &:hover,
      &:focus-visible {
        background-color: ${theme.color.neutral[900]};
        border-color: ${theme.color.neutral[900]};
        color: ${theme.color.white};

        svg {
          fill: ${theme.color.white};
        }
      }
    `}
`;

const FilterButton: React.FC<IFilterButton> = ({ filterActive, appliedFilters, ...rest }) => (
  <StyledButton data-cy="filter-button" label={`Filters${appliedFilters > 0 ? ` (${appliedFilters})` : ''}`} appearance="white" icon="Filter" size="small" type="button" filterActive={filterActive} {...rest} />
);

export default FilterButton;
